module.exports = __webpack_public_path__ + "media/images/about/about-image2-55bbc81958701f0d25df880b34dbda05.jpg";